import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./knowledge.css";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { apiService } from '../../services/apiService';
import { Modal } from 'react-bootstrap';
function UnderApprovalHistory() {
    const location = useLocation();
    const currentPath = location.pathname;
    const navigate = useNavigate();
    const [catesNames,setCateNames] = useState('');
    const [articleDetail, setArticleDetail] = useState([]);
    const [articles, setArticles] = useState([]);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const { id } = useParams();

    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState(null);
  
    const handleClose = () => setShow(false);
  
    const handleShow = (data) => {
      setModalData(data);
      setShow(true);
    };
    const [show2, setShow2] = useState(false);
    const [modalData2, setModalData2] = useState(null);
  
    const handleClose2 = () => setShow2(false);
  
    const handleShow2 = (data) => {
      setModalData2(data);
      setShow2(true);
    };

    const [show3, setShow3] = useState(false);
    const [modalData3, setModalData3] = useState(null);
  
    const handleClose3 = () => setShow3(false);
  
    const handleShow3 = (data) => {
      setModalData3(data);
      setShow3(true);
    };

    useEffect(() => {
        const fetchPreviewData = async () => {
            try {
                const response = await apiService.getRequest(`knowledge-article/${id}`);
                if (response && response.success) {
                    setCateNames(response.data.subcategory);
                    setArticleDetail(response.data);
                }else{
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (error) {
                console.error('Error fetching article data:', error);
            }
        };

        fetchPreviewData();
    }, [id]);

    const fetchHistoryData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = {...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/knowledge-articles/${id}/status-history?${queryString}`);
            if (response && response.success === true && response.data) {
                    setArticles(response.data);
                    setPaginateData(response.meta);
                } else {
                    setArticles([]);
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                } 
            } catch (error) {
                console.error('Error fetching article data:', error);
                setArticles([]);
            } finally {
                setLoading(false);
            }
    }, [id]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchHistoryData({ page: newPage });
    };

    useEffect(() => {
        fetchHistoryData();
    }, [fetchHistoryData]);
    
    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';

        // Handle both \n and \r\n (Windows/Mac/Linux line endings)
        const formattedHTML = html
            .replace(/(\r\n|\r|\n){2,}/g, '<br><br>') // double line breaks
            .replace(/(\r\n|\r|\n)/g, '<br>');        // single line breaks

        return formattedHTML;
    };

    // Older history rows stored dates as full ISO timestamps
    const formatHistoryDate = (value) => {
        if (!value || value === '-') return 'N/A';
        const datePart = String(value).match(/^\d{4}-\d{2}-\d{2}/);
        return datePart ? datePart[0] : value;
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center" className="mario_fixers_article">
                    <Grid size={{sm:12}} container alignItems="center">
                        {articleDetail && articleDetail.status === "under_approval" ? (
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                                <h3>Under Approval</h3>
                                <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "draft" ? (
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                                <h3>Draft</h3>
                                <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "published" ? (
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                                <h3>Published</h3>
                                <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                            </Grid>
                        ):""}
                        {articleDetail && articleDetail.status === "retired" ? (
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                                <h3>Retired</h3>
                                <span>{catesNames.knowledge_base} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.category_name} <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {catesNames.name}</span>
                            </Grid>
                        ):""}
                    </Grid>
                </Grid>
                {loading ? (
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div>
                ) : (
                    <>
                <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn mt-4">
                    <div className='knowledgetab_btnredirect'>
                        <button onClick={() =>{navigate(`/knowledge/edit-article/${id}`)}}>Article</button>
                        {articleDetail && articleDetail.status === "draft" ? <button onClick={() =>{navigate(`/knowledge/assignments/${id}`)}}>Assignment</button>:
                        <button onClick={() =>{navigate(`/knowledge/under-approval/show/${id}`)}}>Approvals</button>}
                        <button className={currentPath.startsWith("/knowledge/history") ? "active_tabbtn" : ""} onClick={() =>{navigate(`/knowledge/history/${id}`)}}>History</button>
                        <button onClick={() =>{navigate(`/knowledge/attachments/${id}`)}}>Attachments</button>
                        <button onClick={() =>{navigate(`/knowledge/discussions/${id}`)}}>Discussions</button>
                        <button onClick={() =>{navigate(`/knowledge/versions/${id}`)}}>Versions</button>
                    </div>
                </Grid>
                <div className='overtanblehistory w-100'>
                    <Grid size={{xs:12}} container alignContent="flex-start" className="mt-5 tablemin_height">
                        <Grid size={{xs:12}} container className="history_tableheads">
                            <Grid size={{xs:2}} container>
                                <h6>Name</h6>
                            </Grid>  
                            <Grid size={{xs:4}} container>
                                <h6>Old Data</h6>
                            </Grid>
                            <Grid size={{xs:4}} container>
                                <h6>New Data</h6>
                            </Grid>
                            <Grid size={{xs:2}} container>
                                <h6>Updated</h6>
                            </Grid>
                        </Grid>
                        {articles && articles.length > 0 ? ( articles && articles.map((article) => (
                            <Grid size={{xs:12}} key={article.id} alignItems="center" container className="history_tableans">
                                <Grid size={{xs:2}} container>
                                    <span>{article.changed_by}</span>
                                </Grid>
                                <Grid size={{xs:4}} container flexDirection="column">
                                {article.changes && (  
                                    <>
                                        {article.changes.title && (
                                            <span>
                                                <b>Title :</b> {article.changes.title.old || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.is_external && (
                                            <span>
                                                <b>External :</b> {article.changes.is_external.old === 1 ? "True" : article.changes.is_external.old === 0 ? "False" : article.changes.is_external.old}
                                            </span>
                                        )}
                                        {article.changes.is_preview_render && (
                                            <span>
                                                <b>Export PDF :</b> {article.changes.is_preview_render.old === 1 ? "True" : article.changes.is_preview_render.old === 0 ? "False" : article.changes.is_preview_render.old}
                                            </span>
                                        )}
                                        {article.changes.retired_date && (
                                            <span>
                                                <b>Retired date :</b> {formatHistoryDate(article.changes.retired_date.old)}
                                            </span>
                                        )}
                                        {article.changes.planned_release_date && (
                                            <span>
                                                <b>Planned release date :</b> {formatHistoryDate(article.changes.planned_release_date.old)}
                                            </span>
                                        )}
                                        {article.changes.base_id && (
                                            <span> 
                                                <b>Knowledge Base :</b> {article.changes.base_id.old || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.category_id && (
                                            <span>
                                                <b>Category ID :</b> {article.changes.category_id.old || 'N/A'}
                                            </span>
                                        )}  
                                        {article.changes.subcategory_id && (
                                            <span>
                                                <b>Subcategory ID :</b> {article.changes.subcategory_id.old || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.case_type_id && (
                                            <span>
                                                <b>Case Type :</b> {article.changes.case_type_id.old ? (
                                                    article.changes.case_type_id.old.length <= 25 ? (
                                                        article.changes.case_type_id.old
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.changes.case_type_id.old)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}  
                                        {article.changes.case_sub_type_id && (
                                            <span>
                                                <b>Case Sub Type :</b> {article.changes.case_sub_type_id.old ? (
                                                    article.changes.case_sub_type_id.old.length <= 25 ? (
                                                        article.changes.case_sub_type_id.old
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.changes.case_sub_type_id.old)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}
                                        {article.changes.documents && (
                                            <span>
                                                <b>Attachments</b> 
                                                {Array.isArray(article?.changes?.documents?.old) && article.changes.documents.old.length > 0 &&
                                                    article.changes.documents.old.some(data => data.doc_name !== "-") ? (
                                                        article.changes.documents.old.map((data, index) => 
                                                            data.doc_name !== "-" ? (
                                                                <div key={index}><a key={index} href={`${data.doc_path}`} target="_blank" rel="noopener noreferrer" className='linkofhistoryattach'>{data.doc_name}</a></div>
                                                            ) : null
                                                        )
                                                    ) : (
                                                        <span>: -</span>
                                                    )
                                                }
                                            </span>
                                        )}
                                        {article.changes.tags && (
                                                <span>
                                                <b>Tags :</b> {article.changes.tags.old || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.task_type && (
                                            <span>
                                                <b>Task type :</b> {article.changes.task_type.old || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.short_description && (
                                            <span>
                                                <b>Description :</b> <button className='view_btnhist_kn' onClick={() => handleShow(article.changes.short_description.old || 'N/A')}>View</button>
                                            </span>
                                        )}
                                        {article.changes.content && (
                                            <span>
                                                <b>Content :</b> <button className='view_btnhist_kn' onClick={() => handleShow2(article.changes.content.old || 'N/A')}>View</button>
                                            </span>
                                        )}
                                        {article.changes.status && (
                                            <span>
                                                <b>Status :</b> {article.changes.status.old ? (
                                                    article.changes.status.old.length <= 20 ? (
                                                        article.changes.status.old
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.changes.status.old)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}
                                        {article.comment && (
                                            <span>
                                                <b>Comment :</b> N/A
                                            </span>
                                        )}
                                        {article.changes.assignment_group && (
                                            <span>
                                                <b>Assignment group :</b> {article.changes.assignment_group.old || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.assigned_to && (
                                            <span>
                                                <b>Assigned to :</b> {article.changes.assigned_to.old || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.reason_for_reassignment && (
                                            <span>
                                                <b>Reason :</b> {" "}
                                                    {article.changes.reason_for_reassignment.old ? (
                                                    article.changes.reason_for_reassignment.old.length <= 10 ? (
                                                        article.changes.reason_for_reassignment.old
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.changes.reason_for_reassignment.old)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}
                                    </>
                                )}
                                </Grid>
                                <Grid size={{xs:4}} container flexDirection="column">
                                {article.changes && (
                                    <>
                                        {article.changes.title && (
                                            <span>
                                                <b>Title :</b> {article.changes.title.new || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.is_external && (
                                            <span>
                                                <b>External :</b> {article.changes.is_external.new === 1 ? "True" : article.changes.is_external.new === 0 ? "False" : article.changes.is_external.new}
                                            </span>
                                        )}
                                        {article.changes.is_preview_render && (
                                            <span>
                                                <b>Export PDF :</b> {article.changes.is_preview_render.new === 1 ? "True" : article.changes.is_preview_render.new === 0 ? "False" : article.changes.is_preview_render.new}
                                            </span>
                                        )}
                                        {article.changes.retired_date && (
                                            <span>
                                                <b>Retired date :</b> {formatHistoryDate(article.changes.retired_date.new)}
                                            </span>
                                        )}
                                        {article.changes.planned_release_date && (
                                            <span>
                                                <b>Planned release date :</b> {formatHistoryDate(article.changes.planned_release_date.new)}
                                            </span>
                                        )}
                                        {article.changes.base_id && (
                                            <span>
                                                <b>Knowledge Base :</b> {article.changes.base_id.new || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.category_id && (
                                            <span>
                                                <b>Category ID :</b> {article.changes.category_id.new || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.subcategory_id && (
                                            <span>
                                                <b>Subcategory ID :</b> {article.changes.subcategory_id.new || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.case_type_id && (
                                            <span>
                                                <b>Case Type :</b> {article.changes.case_type_id.new ? (
                                                    article.changes.case_type_id.new.length <= 25 ? (
                                                        article.changes.case_type_id.new
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.changes.case_type_id.new)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}  
                                        {article.changes.case_sub_type_id && (
                                            <span>
                                                <b>Case Sub Type :</b> {article.changes.case_sub_type_id.new ? (
                                                    article.changes.case_sub_type_id.new.length <= 25 ? (
                                                        article.changes.case_sub_type_id.new
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.changes.case_sub_type_id.new)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}
                                        {article.changes.documents && (
                                            <span>
                                                <b>Attachments</b> 
                                                {Array.isArray(article?.changes?.documents?.new) && article.changes.documents.new.length > 0 &&
                                                    article.changes.documents.new.some(data => data.doc_name !== "-") ? (
                                                        article.changes.documents.new.map((data, index) => 
                                                            data.doc_name !== "-" ? (
                                                                <div key={index}><a key={index} href={`${data.doc_path}`} target="_blank" rel="noopener noreferrer" className='linkofhistoryattach'>{data.doc_name}</a></div>
                                                            ) : null
                                                        )
                                                    ) : (
                                                        <span>: -</span>
                                                    )
                                                }
                                            </span>
                                        )}
                                        {article.changes.tags && (
                                            <span>
                                                <b>Tags :</b> {article.changes.tags.new || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.task_type && (
                                            <span>
                                                <b>Task type :</b> {article.changes.task_type.new || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.short_description && (
                                            <span>
                                                <b>Description :</b> <button className='view_btnhist_kn' onClick={() => handleShow(article.changes.short_description.new || 'N/A')}>View</button>
                                            </span>
                                        )}
                                        {article.changes.content && (
                                            <span>
                                                <b>Content :</b> <button className='view_btnhist_kn' onClick={() => handleShow2(article.changes.content.new || 'N/A')}>View</button>
                                            </span>
                                        )}
                                        {article.changes.status && (
                                            <span>
                                                <b>Status :</b> {article.changes.status.new ? (
                                                    article.changes.status.new.length <= 20 ? (
                                                        article.changes.status.new
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.changes.status.new)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}
                                        {article.comment && (
                                            <span>
                                                <b>Comment :</b> {article.comment ? (
                                                    article.comment.length <= 10 ? (
                                                        article.comment
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.comment)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}
                                        {article.changes.assignment_group && (
                                            <span>
                                                <b>Assignment group :</b> {article.changes.assignment_group.new || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.assigned_to && (
                                            <span>
                                                <b>Assigned to :</b> {article.changes.assigned_to.new || 'N/A'}
                                            </span>
                                        )}
                                        {article.changes.reason_for_reassignment && (
                                            <span>
                                                <b>Reason :</b> {article.changes.reason_for_reassignment.new ? (
                                                    article.changes.reason_for_reassignment.new.length <= 10 ? (
                                                        article.changes.reason_for_reassignment.new
                                                    ) : (
                                                        <button
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow3(article.changes.reason_for_reassignment.new)}
                                                        >
                                                        View
                                                        </button>
                                                    )
                                                    ) : (
                                                    'N/A'
                                                    )}
                                            </span>
                                        )}
                                    </>
                                )}
                                </Grid>
                                <Grid size={{xs:2}} container>
                                    <span>{article.changed_at}</span>
                                </Grid>
                            </Grid>
                        ))
                        ) : (
                            <div className="w-100 d-flex justify-content-center mt-4">
                                <p>No data to display</p>
                            </div>
                        )}
                    </Grid>
                </div>
                <Grid size={{xs:12}} container justifyContent="center" className="mt-5 mb-4 pagination_btn">
                    <button className='arrowpaginate'
                        onClick={() => handlePageChange(currentPage - 1)} 
                        disabled={currentPage === 1}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    {paginatedata && (
                        <div className="pagination">
                            {(() => {
                            const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                            const pages = [];
                            const start = Math.max(2, currentPage - 2);
                            const end = Math.min(totalPages - 1, currentPage + 2);

                            // Always show first page
                            pages.push(
                                <button
                                key={1}
                                onClick={() => handlePageChange(1)}
                                className={currentPage === 1 ? 'active' : ''}
                                >
                                1
                                </button>
                            );

                            if (start > 2) {
                                pages.push(<span key="start-ellipsis">...</span>);
                            }

                            for (let i = start; i <= end; i++) {
                                pages.push(
                                <button
                                    key={i}
                                    onClick={() => handlePageChange(i)}
                                    className={currentPage === i ? 'active' : ''}
                                >
                                    {i}
                                </button>
                                );
                            }

                            if (end < totalPages - 1) {
                                pages.push(<span key="end-ellipsis">...</span>);
                            }

                            if (totalPages > 1) {
                                pages.push(
                                <button
                                    key={totalPages}
                                    onClick={() => handlePageChange(totalPages)}
                                    className={currentPage === totalPages ? 'active' : ''}
                                >
                                    {totalPages}
                                </button>
                                );
                            }

                            return pages;
                            })()}
                        </div>
                    )}

                    <button className='arrowpaginate'
                        onClick={() => handlePageChange(currentPage + 1)} 
                        disabled={currentPage === paginatedata.last_page}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </Grid>
                </>)}
            </Grid>
            <Modal size='lg' centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Description</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mb-3'><div className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(modalData) }} /></Modal.Body>
            </Modal>
            <Modal size='lg' centered show={show2} onHide={handleClose2}>
                <Modal.Header closeButton>
                <Modal.Title>Content</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mb-3'><div className='w-100 caliberifontsset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(modalData2) }} /></Modal.Body>
            </Modal>
            <Modal size='lg' centered show={show3} onHide={handleClose3}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className='mb-3'><div className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(modalData3) }} /></Modal.Body>
            </Modal>
        </div>
    </div>
  )
}

export default UnderApprovalHistory
